import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      title: 'Concrete & Patios',
      description: 'Professional concrete installation for residential properties throughout the Dallas-Fort Worth area. We specialize in stamped concrete, decorative finishes, and durable outdoor surfaces.',
      image: 'https://public.readdy.ai/ai/img_res/bf2cf37aac0e380a334b51aca1db26b6.jpg',
      features: [
        'Stamped & Decorative Concrete',
        'Concrete Slabs & Foundations',
        'Patio Installations',
        'Walkways & Driveways',
        'Concrete Repairs & Resurfacing',
        'Custom Color & Texture Options',
      ],
    },
    {
      title: 'Screened-In Porches',
      description: 'Transform your outdoor space into a comfortable, bug-free living area. Our screened porch installations provide year-round enjoyment of your backyard.',
      image: 'https://readdy.ai/api/search-image?query=Screened-in%20porch%20construction%20showing%20dark%20frame%20installation%20and%20white%20screen%20material%2C%20Dallas%20Fort%20Worth%20home%20exterior%2C%20professional%20contractor%20work%20in%20progress%2C%20simple%20clean%20background%2C%20construction%20detail%20photography&width=1200&height=800&seq=service-porch-detail-9&orientation=landscape',
      features: [
        'Custom Screened Enclosures',
        'Patio Conversions',
        'Screen Door Installation',
        'Electrical & Lighting Integration',
        'Ceiling Fan Installation',
        'Weather-Resistant Materials',
      ],
    },
    {
      title: 'Fences & Gates',
      description: 'Quality fence installation and repair services for privacy, security, and curb appeal. We work with wood, composite, and metal materials.',
      image: 'https://readdy.ai/api/search-image?query=Wood%20fence%20installation%20in%20progress%20showing%20horizontal%20cedar%20planks%20being%20installed%20with%20professional%20tools%2C%20Dallas%20Texas%20residential%20property%2C%20construction%20detail%20work%2C%20simple%20clean%20background%2C%20high%20quality%20craftsmanship%20photography&width=1200&height=800&seq=service-fence-detail-10&orientation=landscape',
      features: [
        'Wood Privacy Fences',
        'Horizontal & Vertical Designs',
        'Custom Gates & Entries',
        'Fence Repairs & Replacement',
        'Staining & Sealing Services',
        'Post Installation & Concrete',
      ],
    },
    {
      title: 'Pergolas & Patio Covers',
      description: 'Add shade and style to your outdoor living space with custom pergolas and patio covers designed to complement your home.',
      image: 'https://readdy.ai/api/search-image?query=Pergola%20construction%20showing%20wooden%20beam%20installation%20and%20structural%20framework%2C%20Dallas%20Fort%20Worth%20backyard%20setting%2C%20professional%20carpentry%20work%2C%20simple%20clean%20background%2C%20construction%20detail%20photography&width=1200&height=800&seq=service-pergola-detail-11&orientation=landscape',
      features: [
        'Custom Pergola Design',
        'Attached & Freestanding Structures',
        'Patio Cover Installation',
        'Shade Solutions',
        'Integrated Lighting Options',
        'Durable Weather-Resistant Materials',
      ],
    },
    {
      title: 'Interior Remodeling',
      description: 'Complete interior renovation services including mudrooms, built-ins, drywall, and painting to enhance your home\'s functionality and appearance.',
      image: 'https://readdy.ai/api/search-image?query=Interior%20remodeling%20work%20showing%20custom%20built-in%20shelving%20installation%20and%20drywall%20finishing%2C%20Dallas%20Texas%20home%20interior%2C%20professional%20carpentry%20and%20construction%2C%20simple%20clean%20background%2C%20high%20quality%20craftsmanship%20photography&width=1200&height=800&seq=service-interior-detail-12&orientation=landscape',
      features: [
        'Mudroom Construction',
        'Custom Built-In Shelving',
        'Drywall Installation & Repair',
        'Interior Painting',
        'Trim & Molding Work',
        'Room Additions & Conversions',
      ],
    },
    {
      title: 'General Home Improvements',
      description: 'Comprehensive home improvement services to maintain and upgrade your property. From repairs to renovations, we handle it all.',
      image: 'https://readdy.ai/api/search-image?query=General%20home%20improvement%20work%20showing%20various%20construction%20tools%20and%20materials%2C%20Dallas%20Fort%20Worth%20residential%20property%2C%20professional%20contractor%20equipment%2C%20simple%20clean%20background%2C%20construction%20photography&width=1200&height=800&seq=service-general-detail-13&orientation=landscape',
      features: [
        'Home Repairs & Maintenance',
        'Deck Construction & Repair',
        'Door & Window Installation',
        'Siding & Exterior Work',
        'Carpentry Services',
        'Project Consultation',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20construction%20contractor%20working%20on%20outdoor%20project%20with%20tools%20and%20materials%2C%20Dallas%20Fort%20Worth%20Texas%20residential%20setting%2C%20high%20quality%20construction%20photography%20showing%20craftsmanship%20and%20attention%20to%20detail%2C%20simple%20clean%20background&width=1920&height=1080&seq=services-hero-vantex-14&orientation=landscape"
            alt="Vantex Construction Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 w-full text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6"
          >
            OUR SERVICES
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-neutral-lighter-gray max-w-3xl mx-auto"
          >
            Professional residential construction and remodeling services for Dallas-Fort Worth homeowners
          </motion.p>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="space-y-24">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <h2 className="text-4xl md:text-5xl font-black text-neutral-charcoal mb-6">
                    {service.title}
                  </h2>
                  <p className="text-lg text-neutral-gray mb-8 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-4 mb-8">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-start">
                        <i className="ri-checkbox-circle-fill text-primary-red mr-3 mt-1 text-xl w-6 h-6 flex items-center justify-center"></i>
                        <span className="text-neutral-charcoal font-medium">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/quote"
                    className="inline-flex items-center bg-primary-red hover:bg-primary-red-dark text-white px-8 py-4 font-bold text-base tracking-wide transition-colors whitespace-nowrap cursor-pointer"
                  >
                    GET A QUOTE
                    <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
                  </Link>
                </div>
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="rounded-lg overflow-hidden shadow-2xl">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="bg-neutral-black py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              OUR PROCESS
            </h2>
            <p className="text-lg text-neutral-light-gray max-w-3xl mx-auto">
              Simple, transparent, and professional from start to finish
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: 'Contact Us',
                description: 'Reach out by phone or request a quote online',
              },
              {
                step: '02',
                title: 'Site Visit',
                description: 'We visit your property to assess the project',
              },
              {
                step: '03',
                title: 'Detailed Estimate',
                description: 'Receive a clear, written estimate with no surprises',
              },
              {
                step: '04',
                title: 'Quality Work',
                description: 'Professional construction backed by our warranty',
              },
            ].map((item, index) => (
              <motion.div
                key={item.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="text-6xl font-black text-primary-red mb-4">{item.step}</div>
                <h3 className="text-2xl font-bold text-white mb-3">{item.title}</h3>
                <p className="text-neutral-light-gray">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-neutral-charcoal mb-6">
            READY TO GET STARTED?
          </h2>
          <p className="text-xl text-neutral-gray mb-10 max-w-2xl mx-auto">
            Contact us today for a free, detailed estimate on your project
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center bg-primary-red hover:bg-primary-red-dark text-white px-10 py-5 font-bold text-lg tracking-wide transition-colors whitespace-nowrap cursor-pointer"
          >
            REQUEST FREE ESTIMATE
            <i className="ri-arrow-right-line ml-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;